module.exports = __webpack_public_path__ + "static/img/personal_banner_bg.905ac4b7.png";